var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"double-bar-page"},[_c('div',{ref:"doubleBar",staticClass:"charts"})])
}
var staticRenderFns = []

export { render, staticRenderFns }